import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PlayerAvatar } from "./PlayerAvatar";
import { Swords, Flame } from "lucide-react";

function FormDots({ form }) {
  const last = (form || []).slice(-5);
  if (last.length === 0) return <span className="text-[10px] text-slate-600">nessuna partita</span>;
  return (
    <div className="flex gap-1">
      {last.map((r, i) => (
        <span
          key={i}
          title={r === "V" ? "Vittoria" : "Sconfitta"}
          className={`w-2.5 h-2.5 rounded-full ${r === "V" ? "bg-emerald-400" : "bg-rose-500/70"}`}
        />
      ))}
    </div>
  );
}

export function RivalryCard({ onSelectPlayer }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/rivalry").then((r) => setData(r.data)).catch(() => setData({ found: false }));
  }, []);

  if (!data || !data.found) return null;

  const h = data.h2h || {};
  const ctxLabel = data.context?.type === "next"
    ? `Prossima sfida · Giornata ${data.context.matchday} · Campo ${data.context.court}`
    : "I due più in forma del momento";

  const Side = ({ id, name, short, form, wins, align }) => (
    <button
      data-testid={`rivalry-player-${id}`}
      onClick={() => onSelectPlayer?.(id)}
      className={`flex-1 min-w-0 flex flex-col items-center gap-2 group ${align}`}
    >
      <PlayerAvatar id={id} name={name} size={56} />
      <span className="font-semibold text-white text-sm truncate max-w-full group-hover:text-emerald-400 transition-colors">{name}</span>
      <FormDots form={form} />
      <span className="font-display font-black text-3xl text-white">{wins}</span>
    </button>
  );

  return (
    <div className="ap-card p-5 relative overflow-hidden" data-testid="rivalry-card">
      <div className="absolute -right-6 -top-6 opacity-[0.07]">
        <Swords className="w-40 h-40 text-white" />
      </div>
      <div className="relative flex items-center gap-2 mb-1">
        <Swords className="w-5 h-5 text-amber-400" />
        <h3 className="font-display uppercase tracking-wide text-lg text-white">La sfida della settimana</h3>
      </div>
      <p className="relative text-xs text-slate-400 mb-5 flex items-center gap-1.5">
        <Flame className="w-3.5 h-3.5 text-orange-400" /> {ctxLabel}
      </p>

      <div className="relative flex items-center gap-4">
        <Side id={data.a_id} name={data.a_name} short={data.a} form={data.a_form} wins={h.a_wins ?? 0} align="items-center" />
        <div className="flex flex-col items-center shrink-0">
          <span className="font-display font-black text-xl text-slate-600">VS</span>
          <span className="text-[10px] uppercase tracking-widest text-slate-500 mt-1">
            {h.played ? `${h.played} sfide` : "mai affrontati"}
          </span>
        </div>
        <Side id={data.b_id} name={data.b_name} short={data.b} form={data.b_form} wins={h.b_wins ?? 0} align="items-center" />
      </div>
    </div>
  );
}
